module.exports = __webpack_public_path__ + "img/logo.1bb46bb0.svg";